import { ApiTesterComponent } from "./pages/api-tester/api-tester.component";
import { CreateKeyComponent } from "./pages/create-key/create-key.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { InspectTokensComponent } from "./pages/inspect-tokens/inspect-tokens.component";
import { IntrospectKeyComponent } from "./pages/introspect-key/introspect-key.component";

export const V0_Pages = {
  ApiTesterComponent,
  CreateKeyComponent,
  DashboardComponent,
  InspectTokensComponent,
  IntrospectKeyComponent,
};